






import { Component, Vue } from "vue-property-decorator"
import LoginView from './components/LoginView.vue'
import CatalogView from './components/CatalogView.vue'
import authentication from './services/AuthenticationService'

@Component
export default class App extends Vue {

  get view () {
    return authentication.state.authenticated ? CatalogView : LoginView
  }

}
